import type { TableRowCell } from '@/components/webcomponents/DataTable/types/Table.type'

const cellWithSubtextTemplate = document.createElement('template')
cellWithSubtextTemplate.innerHTML = `
  <div class="cell-with-subtext" exportparts="cell-with-subtext">
    <div class="cell-text" exportparts="cell-text">{{ text }}</div>
    <div class="cell-subtext" exportparts="cell-subtext">{{ subtext }}</div>
  </div>
`

export function createSubtextCell(cell: TableRowCell): HTMLTableCellElement {
  const td = document.createElement('td')
  td.part = 'cell'
  const cellTemplate = cellWithSubtextTemplate.content.cloneNode(true) as HTMLElement
  const textElement = cellTemplate.querySelector('.cell-text')
  if (textElement) {
    textElement.textContent = cell.text || ''
  }

  const subtextElement = cellTemplate.querySelector('.cell-subtext')
  if (subtextElement) {
    subtextElement.textContent = cell.subtext || ''
  }

  td.appendChild(cellTemplate)

  return td
}
